import { AppState } from '../initialStateRegistration';

const getHeader = (state:AppState) => state.primaryHeader;

export const getLogos = (state:AppState) => getHeader(state).logo;

export const getLinks = (state:AppState) => getHeader(state).links;

export const getEditionsLinks = (state:AppState) => getHeader(state).editionsLinks;

export const getCta = (state:AppState) => getHeader(state).cta;

export const getMenu = (state:AppState) => getHeader(state).menu;

export const getVideoLogo = (state:AppState) => getHeader(state).videoLogo;
